export const AnimalTypes = {
    SOW: 0,
    PIG: 1,
    PIGLET: 2,
    PORKER: 3,
    BOAR: 4,
    RENOVATION_SOW: 5
};
